import { ROLES } from "@shared/constants"

/**
 * Permisos de Logística en la Suite (espejo de `logistics-roles.ts` del back).
 *
 * `logistics-rider-view` deja ver las pantallas; `logistics-rider-manage` y `admin` pueden toda acción; y hay permisos
 * finos por acción (2026-10-07): crear, editar, asignar, confirmar, cancelar y eliminar puntos de entrega y recojo, y
 * crear y editar repartidores. Cualquier permiso fino también deja entrar a las pantallas y consultar.
 */
export interface LogisticsPermissions {
  view: boolean
  stopCreate: boolean
  stopEdit: boolean
  stopAssign: boolean
  stopConfirm: boolean
  stopCancel: boolean
  stopDelete: boolean
  riderCreate: boolean
  riderEdit: boolean
  /** Alguna acción sobre puntos de entrega o recojo (para mostrar la columna "Acciones") */
  anyStopAction: boolean
  /** Alguna acción sobre un punto manual (asignar, editar o cancelar) */
  anyManualAction: boolean
}

const FINE_ROLES = [
  ROLES.LOGISTICS_STOP_CREATE,
  ROLES.LOGISTICS_STOP_EDIT,
  ROLES.LOGISTICS_STOP_ASSIGN,
  ROLES.LOGISTICS_STOP_CONFIRM,
  ROLES.LOGISTICS_STOP_CANCEL,
  ROLES.LOGISTICS_STOP_DELETE,
  ROLES.LOGISTICS_RIDER_CREATE,
  ROLES.LOGISTICS_RIDER_EDIT
]

type HasRole = (role: string) => boolean

/** Entrar a las pantallas de Logística y consultar: cualquier permiso de logística lo incluye */
export const canViewLogistics = (hasRole: HasRole): boolean => hasRole(ROLES.ADMIN) || hasRole(ROLES.LOGISTICS_RIDER_VIEW) || hasRole(ROLES.LOGISTICS_RIDER_MANAGE) || FINE_ROLES.some((role) => hasRole(role))

export const logisticsPermissions = (hasRole: HasRole): LogisticsPermissions => {
  const all = hasRole(ROLES.ADMIN) || hasRole(ROLES.LOGISTICS_RIDER_MANAGE)
  const stopCreate = all || hasRole(ROLES.LOGISTICS_STOP_CREATE)
  const stopEdit = all || hasRole(ROLES.LOGISTICS_STOP_EDIT)
  const stopAssign = all || hasRole(ROLES.LOGISTICS_STOP_ASSIGN)
  const stopConfirm = all || hasRole(ROLES.LOGISTICS_STOP_CONFIRM)
  const stopCancel = all || hasRole(ROLES.LOGISTICS_STOP_CANCEL)
  const stopDelete = all || hasRole(ROLES.LOGISTICS_STOP_DELETE)
  return {
    view: canViewLogistics(hasRole),
    stopCreate,
    stopEdit,
    stopAssign,
    stopConfirm,
    stopCancel,
    stopDelete,
    riderCreate: all || hasRole(ROLES.LOGISTICS_RIDER_CREATE),
    riderEdit: all || hasRole(ROLES.LOGISTICS_RIDER_EDIT),
    anyStopAction: stopCreate || stopEdit || stopAssign || stopConfirm || stopCancel || stopDelete,
    anyManualAction: stopEdit || stopAssign || stopCancel
  }
}
